// @flow
import type {Language, DataToExportOption} from '@/types'
import React, {Component} from 'react'
import {connect} from 'react-redux'
import {appSelectors} from '@/store'
import {any, append, contains, equals, map, reject, difference, concat} from 'ramda'

type Props = {
  l: Language,
  label: string,
  options: Array<DataToExportOption>,
  defaultOptions?: Array<string>,
  selected: Array<string>,
  onChange: (Array<string>) => void,
  disable?: boolean,
  helpTextPrefix?: string,
  helpText?: string,
}

const isAllOption = equals('All')
const allOptions = ['All']

export class RawRadioSelect extends Component<Props, *> {
  constructor (props: Props) {
    super(props)
    let options = map(this.getOptions, props.options)
    const startingSet = any(isAllOption, props.selected)
      ? options
      : props.selected

    this.state = {
      selected: startingSet,
    }
  }
  getOptions = (option: Object) => {
    return option['name']
  }

  update = (e: any) => {
    const {checked, value} = e.currentTarget

    return isAllOption(value)
      ? this.updateAll(checked)
      : this.updateOne(value, checked)
  }

  removeOption = (value: string) => (prevSelectedValue: string) => {
    if (value === prevSelectedValue || prevSelectedValue === 'All') {
      return true
    }
    return false
  }

  isAllOptionsSelected = (value: string) => (selectedList: Array<string>) => {
    let options = map(this.getOptions, this.props.options)
    let differenceList = difference(options, selectedList)
    if (differenceList.length === 2) {
      return concat(differenceList, selectedList)
    }
    return append(value, selectedList)
  }

  updateOne = (value: string, checked: boolean) => {
    this.setState((prevState) => {
      const newList = checked
        ? this.isAllOptionsSelected(value)(prevState.selected)
        : reject(this.removeOption(value), prevState.selected)

      this.props.onChange(newList)

      return {
        selected: newList,
      }
    })
  }

  updateAll = (checked: boolean) => {
    let updatedOptions = this.props.options
    let options = map(this.getOptions, updatedOptions)
    let {defaultOptions = []} = this.props
    this.setState({
      selected: checked ? options : defaultOptions,
    })
    this.props.onChange(checked ? allOptions : defaultOptions)
  }

  renderOption = (option: DataToExportOption) =>
    <div className="exports-checkbox" key={option.name}>
      <label>
        <input
          type="checkbox"
          checked={contains(option.name, this.state.selected)}
          value={option.name}
          onChange={this.update}
          disabled={this.props.disable || option.disabled}
        />
        {this.props.l(option.displayName || option.name)}
      </label>
    </div>

  render = () =>
    <div>
      <div className='data-to-export'>
        <label className='export-field-name'>{this.props.l(this.props.label)}</label>
        {map(this.renderOption, this.props.options)}
        {this.props.helpTextPrefix ? <span className='recommended-text'>{this.props.l(this.props.helpTextPrefix)}</span> : false}
        {this.props.helpText ? <span className='recommended-text'>{this.props.l(this.props.helpText)}</span> : false}
      </div>
    </div>

  componentWillReceiveProps = (nextProps: Props) => {
    if (nextProps.defaultOptions && this.props.defaultOptions) {
      if (nextProps.defaultOptions.length !== this.props.defaultOptions.length) {
        const selectedOptsWithoutDefaults = this.state.selected.filter((opt) => this.props.defaultOptions &&
        !this.props.defaultOptions.includes(opt))
        const nextDefaultOptions = nextProps.defaultOptions || []
        let nextSelectedOptions = [...selectedOptsWithoutDefaults, ...nextDefaultOptions]
        this.setState((prevState) => {
          return {
            selected: nextSelectedOptions,
          }
        })
      }
    }
  }
}

const mapStateToProps = (state) => ({
  l: appSelectors.getL(state),
})

export default connect(
  mapStateToProps,
)(RawRadioSelect)



// WEBPACK FOOTER //
// ./src/controls/checkbox-select.js